import React from 'react';
import { Link } from 'react-router-dom';
import siteContent from '../content';

const { footer, address, email, nav } = siteContent.global;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" data-cms-section="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-about">
            <div className="footer-logo">
              <img src="/logo.svg" alt="Kline Real Estate Works" />
            </div>
            <p style={{ fontStyle: 'italic', color: 'var(--color-gold)', fontSize: '1.1rem', marginBottom: '1rem' }} data-cms-field="tagline">
              {footer.tagline}
            </p>
            <p data-cms-field="description">
              {footer.description}
            </p>
          </div>

          <div className="footer-nav" data-cms-page="global" data-cms-section="nav">
            <h4 data-cms-page="global" data-cms-section="footer" data-cms-field="quickLinksHeading">{footer.quickLinksHeading}</h4>
            <div className="footer-links">
              <Link to="/"><span data-cms-field="home">{nav.home}</span></Link>
              <Link to="/about"><span data-cms-field="about">{nav.about}</span></Link>
              <Link to="/buyers"><span data-cms-field="buyers">{nav.buyers}</span></Link>
              <Link to="/sellers"><span data-cms-field="sellers">{nav.sellers}</span></Link>
              <Link to="/listings"><span data-cms-field="listings">{nav.listings}</span></Link>
              <Link to="/contact"><span data-cms-field="contact">{nav.contact}</span></Link>
            </div>
          </div>

          <div className="footer-services" data-cms-page="global" data-cms-section="footer">
            <h4 data-cms-field="servicesHeading">{footer.servicesHeading}</h4>
            <div className="footer-links" data-cms-list="services">
              {footer.services.map((link, index) => (
                <Link key={index} to={link.link} data-cms-index={index}>
                  <span data-cms-field="services" data-cms-index={index} data-cms-item-field="label">{link.label}</span>
                </Link>
              ))}
            </div>
          </div>

          <div className="footer-contact-info" data-cms-page="global" data-cms-section="footer">
            <h4 data-cms-field="contactHeading">{footer.contactHeading}</h4>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <span className="material-icons">location_on</span>
                <span data-cms-page="global" data-cms-section="address">
                  <span data-cms-field="street">{address.street}</span><br />
                  <span data-cms-field="city">{address.city}</span>, <span data-cms-field="state">{address.state}</span> <span data-cms-field="zip">{address.zip}</span>
                </span>
              </div>
              <div className="footer-contact-item">
                <span className="material-icons">email</span>
                <a href={`mailto:${email}`} style={{ color: 'var(--color-gray-300)' }} data-cms-field="email">
                  {email}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Kline Real Estate Works. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/terms-of-use">Terms of Use</Link>
            <span>|</span>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </div>
          <div className="footer-social">
            <a href="https://www.facebook.com/profile.php?id=61585922213403" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <span className="material-icons">facebook</span>
            </a>
            <a href="https://www.instagram.com/krew_properties/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-powered-by">
          <a href="https://soomerlabs.com" target="_blank" rel="noopener">
            <img src="/powered-by-soomer.svg" alt="Powered by Soomer" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
